import { PageModel, PanelModel } from '@psyomics/surveyjs-core';
import { createContext, useContext, useMemo } from 'react';

import { Answers, Survey, SurveySet } from '../survey-types';

type RenderContextType = {
  surveySet?: SurveySet;
  selectedRespondentType?: string;
  selectedPageName?: string;
  exampleAnswerJson?: string;
  survey?: Survey;
  answers?: Answers;
  page?: PageModel;
  panel?: PanelModel;
  allAnswers: Record<string, Answers | undefined>;
};
const RenderContext = createContext<RenderContextType>({ surveySet: [], allAnswers: {} });
const useRenderContext = () => useContext(RenderContext);
const useSurveysByRespondentType = () => {
  const { surveySet } = useRenderContext();
  return useMemo(
    () =>
      surveySet
        ? surveySet.reduce<Record<string, Survey | undefined>>(
            (acc, s) => ({
              ...acc,
              [s.respondentType]: s,
            }),
            {}
          )
        : {},
    [surveySet]
  );
};
const useAllRespondentTypes = () => {
  const { surveySet } = useRenderContext();
  return useMemo(() => (surveySet ? surveySet.map((s) => s.respondentType) : []), [surveySet]);
};
const useAnswersForRespondentType = (respondentType: string): Answers | undefined => {
  const { allAnswers } = useRenderContext();
  return allAnswers[respondentType];
};
const useSurveyForRespondentType = (respondentType: string) => {
  const { surveySet } = useRenderContext();

  return surveySet?.find(({ respondentType: rt }) => rt === respondentType);
};

export {
  RenderContext,
  useAllRespondentTypes,
  useAnswersForRespondentType,
  useRenderContext,
  useSurveyForRespondentType,
  useSurveysByRespondentType,
};

export type { RenderContextType };
